import { render } from "./CasesColgate.vue?vue&type=template&id=2f62a61d&scoped=true"
import script from "./CasesColgate.vue?vue&type=script&lang=js"
export * from "./CasesColgate.vue?vue&type=script&lang=js"

import "./CasesColgate.vue?vue&type=style&index=0&id=2f62a61d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f62a61d"]])

export default __exports__